import { network } from '@root/utils'
import { handleReturn, QueryFunction } from '../root'

interface SearchProps {
  searchTerm: string
  businessSlug?: string
}

export interface IHandelsregisterAddressDetails {
  street?: string | null
  postal_code?: string | null
  locality?: string | null
  country?: string | null
}

export interface IHandelsregisterSearchResult {
  name: string
  register_court: string
  register_number: string
  handelsregisternummer: string
  form?: string | null
  status?: string | null
  postal_address?: IHandelsregisterAddressDetails | null
}

export interface IHandelsregisterCompanyDetails {
  name?: string | null
  form?: string | null
  handelsregisternummer?: string | null
  postal_address?: IHandelsregisterAddressDetails | null
}

const searchUrl = (businessSlug?: string) =>
  businessSlug
    ? `v1/integrations/business/${businessSlug}/handelsregister/search/`
    : `v1/integrations/handelsregister/search/`

const detailsUrl = (businessSlug?: string) =>
  businessSlug
    ? `v1/integrations/business/${businessSlug}/handelsregister/company_details/`
    : `v1/integrations/handelsregister/company_details/`

export const handelsregisterCompanySearch: QueryFunction<
  SearchProps,
  IHandelsregisterSearchResult[]
> = async ({ searchTerm, businessSlug }) => {
  const { status, data } = await network.httpClient.request({
    url: searchUrl(businessSlug),
    method: 'GET',
    params: { search: searchTerm },
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}

interface CompanyDetailsProps {
  handelsregisternummer: string
  businessSlug?: string
}

export const fetchHandelsregisterCompanyDetails: QueryFunction<
  CompanyDetailsProps,
  IHandelsregisterCompanyDetails | null
> = async ({ handelsregisternummer, businessSlug }) => {
  const { status, data } = await network.httpClient.request({
    url: detailsUrl(businessSlug),
    method: 'GET',
    params: { handelsregisternummer },
    validateStatus: () => true
  })
  if (status === 404) return null
  return handleReturn({ status, data }) ?? null
}
